import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
// import something here
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
var serverURL = process.env.SERVER_URL;
var releaseName = process.env.CI_COMMIT_TAG || process.env.CI_COMMIT_SHA;
var sentryDSN = process.env.SENTRY_DSN;
var sentryReplaysSessionSampleRate = process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE;
var sentryReplaysOnErrorSampleRate = process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE;
var sentryTracesSampleRate = process.env.SENTRY_TRACES_SAMPLE_RATE;
var sentryProfilesSampleRate = process.env.SENTRY_PROFILES_SAMPLE_RATE; // "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/cli-documentation/boot-files#Anatomy-of-a-boot-file

export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var router, Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            router = _ref.router, Vue = _ref.Vue;

            if (sentryDSN) {
              Sentry.init({
                Vue: Vue,
                dsn: sentryDSN,
                integrations: [new BrowserTracing({
                  routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                  tracePropagationTargets: [serverURL, /^\//]
                }), new Sentry.Replay()],
                // This sets the sample rate to be 10%. You may want this to be 100% while
                // in development and sample at a lower rate in production
                replaysSessionSampleRate: sentryReplaysSessionSampleRate === undefined ? 0 : parseFloat(sentryReplaysSessionSampleRate),
                // If the entire session is not sampled, use the below sample rate to sample
                // sessions when an error occurs.
                replaysOnErrorSampleRate: sentryReplaysOnErrorSampleRate === undefined ? 0.05 : parseFloat(sentryReplaysOnErrorSampleRate),
                // Set tracesSampleRate to 1.0 to capture 100%
                // of transactions for performance monitoring.
                // We recommend adjusting this value in production
                tracesSampleRate: sentryTracesSampleRate === undefined ? 0.001 : parseFloat(sentryTracesSampleRate),
                // Set tracesSampleRate to 1.0 to capture 100%
                profilesSampleRate: sentryProfilesSampleRate === undefined ? 0.001 : parseFloat(sentryProfilesSampleRate),
                release: "timeneye-frontend@".concat(releaseName),
                beforeSend: function beforeSend(event, hint) {
                  var _ref3 = hint.originalException || {},
                      response = _ref3.response;

                  if (response && response.status && (response.status === 401 || response.status === 403 || response.status === 404)) {
                    return null;
                  }

                  return event;
                },
                ignoreErrors: ['Non-Error promise rejection captured', /Loading.*chunk.*failed/]
              });
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();